import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Menu } from '@material-ui/core'

const StyledMenu = withStyles({
	paper: {
		borderRadius: 6,
		minWidth: 280,
		boxShadow: '0px 2px 15px rgba(26, 26, 53, 0.2)'
	}
})((props) => (
	<Menu
		elevation={0}
		getContentAnchorEl={null}
		anchorOrigin={{
			vertical: 'bottom',
			horizontal: 'right'
		}}
		transformOrigin={{
			vertical: 'top',
			horizontal: 'right'
		}}
		{...props}
	/>
))

export default StyledMenu
